import {
    CREATE_USER_FORM_AUDIT_TRIAL,
    FETCH_AUDIT_LOG_BY_USER_FAILURE,
    FETCH_AUDIT_LOG_BY_USER_REQUEST,
    FETCH_AUDIT_LOG_BY_USER_SUCCESS,
    SET_USER_NAME_AUDIT_TRIAL

} from "./auditTrial.actionType";




export const AUDIT_TRIAL = 'auditTrial';

let initialState = {
    loading: false,
    auditLogByUserData: [],
    userform: {
        // startDate: new Date().setDate(new Date().getDate() - 15),
        startDate: new Date(),
        endDate: new Date(),
        username: ''
    },

};

export let auditTrialReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;

    switch (type) {
        case FETCH_AUDIT_LOG_BY_USER_REQUEST:

            return {
                ...state,
                loading: true
            };
        case CREATE_USER_FORM_AUDIT_TRIAL:
            return {
                ...state,
                loading: false,
                userform: {
                    ...state.userform,
                    [payload.key]: payload.value
                }
            };
        case FETCH_AUDIT_LOG_BY_USER_SUCCESS:
            return {
                ...state,
                loading: false,
                auditLogByUserData: updatePayload
            }
        case SET_USER_NAME_AUDIT_TRIAL:
            return {
                ...state,
                username: payload
            };
        case FETCH_AUDIT_LOG_BY_USER_FAILURE:
            return {
                ...state,
                loading: false
            };
        default:
            return state

    }
}